import { AlertTriangle } from "@tamagui/lucide-icons";

import { Text, XStack } from "@/components";

interface SystemMessageProps {
  content: string;
}

export default function SystemMessage({ content }: SystemMessageProps) {
  return (
    <XStack marginVertical="$100" gap="$100" alignItems="center">
      <AlertTriangle flexShrink={0} size={14} color="$textSecondary" />
      <Text size="$2xs" color="$textSecondary">
        {content}
      </Text>
    </XStack>
  );
}
